export const CHAMELEON_FAST_URL = 'https://fast.chameleon.io/';
